import React from 'react';
import { Row, Col } from 'antd';

import AgingReportPreview from './AgingReportPreview';
import ProfitReportPreview from './ProfitReportPreview';
import CustomerMixProfitChart from './CustomerMixProfitChart';
import CustomerMixBillingChart from './CustomerMixBillingChart';
import CustomerBillingProfitChart from './CustomerBillingProfitChart';
import TrendWeeklyBillingProfitChart from './TrendWeeklyBillingProfitChart';
import AverageRatesCustomerReportPreview from './AverageRatesCustomerReportPreview';

import styles from '../UserHomePage.module.less';

export default function FinancialsSection() {

  return (
    <div className={styles.wrapper}>
      <Row gutter={[20, 20]}>
        <Col xs={24} className="d-flex">
          <div className={styles.cardWrapper}>
            <TrendWeeklyBillingProfitChart />
          </div>
        </Col>

        <Col xs={24} xl={16} className="d-flex">
          <div className={styles.cardWrapper}>
            <CustomerBillingProfitChart />
          </div>
        </Col>

        <Col xs={24} xl={8} className="d-flex">
          <div className={styles.flexChart}>
            <div className={styles.cardWrapper}>
              <CustomerMixBillingChart />
            </div>
          </div>
        </Col>

        <Col xs={24} xl={12} className="d-flex">
          <AverageRatesCustomerReportPreview />
        </Col>

        <Col xs={24} xl={12} className="d-flex">
          <CustomerMixProfitChart />
        </Col>

        <Col xs={24} xl={12} className="d-flex">
          <ProfitReportPreview />
        </Col>

        <Col xs={24} xl={12} className="d-flex">
          <AgingReportPreview />
        </Col>
      </Row>
    </div>
  );
}
